
import { defineComponent } from 'vue'
import { formatDate } from '@/helpers/commons/localeHelper'
import { AxiosResponse } from 'axios'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import descriptor from './DownloadsDialogDescriptor.json'
import { downloadDirectFromResponse } from '@/helpers/commons/fileHelper'

interface Download {
    filename: string
    startDate: Date
    alreadyDownloaded: boolean
}
export default defineComponent({
    name: 'role-dialog',
    components: {
        Column,
        DataTable,
        Dialog
    },
    props: {
        visibility: Boolean
    },
    data() {
        return {
            columnDefs: {},
            downloadsList: new Array<Download>(),
            gridOptions: {}
        }
    },
    beforeMount() {
        this.gridOptions = { headerHeight: 30 }
        this.columnDefs = descriptor.columnDefs
    },
    created() {
        this.getDownloads()
    },
    emits: ['update:visibility'],
    methods: {
        closeDialog() {
            this.$emit('update:visibility', false)
        },
        getDate(date) {
            return formatDate(date, 'LLL')
        },
        getDownloads() {
            this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/export/dataset?showAll=true').then(
                (response: AxiosResponse<any>) => {
                    this.downloadsList = response.data
                },
                (error) => console.error(error)
            )
        },
        async downloadContent(data) {
            var encodedUri = encodeURI(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/export/dataset/' + data.id)
            await this.$http
                .get(encodedUri, {
                    responseType: 'arraybuffer', // important...because we need to convert it to a blob. If we don't specify this, response.data will be the raw data. It cannot be converted to blob directly.

                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
                    }
                })
                .then(
                    (response: AxiosResponse<any>) => {
                        if (!data.alreadyDownloaded) {
                            this.$store.commit('updateAlreadyDownloadedFiles')
                        }
                        downloadDirectFromResponse(response)
                    },
                    (error) => console.error(error)
                )
            this.getDownloads()
        },
        deleteAllDownloads() {
            this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/export').then(
                () => {
                    this.downloadsList = []
                    this.$store.commit('setDownloads', { count: { total: 0, unRead: 0 } })
                    this.closeDialog()
                },
                (error) => console.error(error)
            )
        }
    },
    watch: {
        visibility(newVisibility, oldVisibility) {
            if (newVisibility != oldVisibility) this.getDownloads()
        }
    }
})
